/* eslint-disable camelcase */
import { extend } from 'vee-validate';
import {
    required,
    min,
    max,
    regex,
    email,
    confirmed,
    min_value,
    max_value
} from 'vee-validate/dist/rules';
import PhoneNumber from 'awesome-phonenumber';
import {
    postcodeValidator,
    postcodeValidatorExistsForCountry
} from 'postcode-validator';

extend('originallyHidden', {
    validate(value) {
        return true;
    }
});
extend('required', {
    ...required,
    message: '{_field_} is required'
});

extend('money', {
    validate(value) {
        // regex for money
        return !!value.match(
            // Decimals required, commas optional
            /^\$?([0-9]{1,3},([0-9]{3},)*[0-9]{3}|[0-9]+)(\.[0-9][0-9])?$/
        );
    },
    message: '{_field_} must be in currency'
});

extend('minlength', {
    ...min,
    message: 'Must be at least {length} characters'
});

extend('maxlength', {
    ...max,
    message: 'Must be less than {length} characters'
});

extend('regex', {
    ...regex,
    message: 'Invalid format for {regex}'
});

extend('email', {
    ...email,
    message: '{_field_} must be a valid email'
});

extend('phone', {
    params: ['country'],
    validate(value, { country }) {
        const phone = new PhoneNumber(value, country);
        return phone.isValid();
    },
    message: '{_field_} is not a valid phone number'
});

extend('zipcode', {
    params: ['country'],
    validate(value, { country }) {
        if (postcodeValidatorExistsForCountry(country))
            return postcodeValidator(value, country);

        return postcodeValidator(value, 'INTL'); // 'International'
    },
    message: '{_field_} is not a valid postal code'
});

extend('confirm-password', {
    ...confirmed,
    message: 'Passwords must match'
});

extend('min_value', {
    ...min_value,
    message: 'Minimum value is {min}'
});

extend('max_value', {
    ...max_value,
    message: 'Maximum value is {max}'
});

extend('business-hours', {
    validate(value) {
        const validArr = [true];
        const messages = [];

        for (const day in value) {
            if (Array.isArray(value[day].hours)) {
                const validHours = value[day].hours.every(
                    hours => hours.open !== '' && hours.close !== ''
                );
                if (!validHours) {
                    validArr.push(false);
                    messages.push(`Hours for ${day} are incomplete.`);
                }
            }
        }

        if (validArr.every(v => v === true)) {
            return true;
        } else {
            return messages.join('<br>');
        }
    }
});

extend('url', {
    validate(value) {
        // Diego Perini's regex: https://gist.github.com/dperini/729294
        const regex = new RegExp(
            '^' +
                // protocol identifier (optional)
                // short syntax // still required
                '(?:(?:(?:https?|ftp):)?\\/\\/)' +
                // user:pass BasicAuth (optional)
                '(?:\\S+(?::\\S*)?@)?' +
                '(?:' +
                // IP address exclusion
                // private & local networks
                '(?!(?:10|127)(?:\\.\\d{1,3}){3})' +
                '(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})' +
                '(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})' +
                // IP address dotted notation octets
                // excludes loopback network 0.0.0.0
                // excludes reserved space >= 224.0.0.0
                // excludes network & broadcast addresses
                // (first & last IP address of each class)
                '(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])' +
                '(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}' +
                '(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))' +
                '|' +
                // host & domain names, may end with dot
                // can be replaced by a shortest alternative
                // (?![-_])(?:[-\\w\\u00a1-\\uffff]{0,63}[^-_]\\.)+
                '(?:' +
                '(?:' +
                '[a-z0-9\\u00a1-\\uffff]' +
                '[a-z0-9\\u00a1-\\uffff_-]{0,62}' +
                ')?' +
                '[a-z0-9\\u00a1-\\uffff]\\.' +
                ')+' +
                // TLD identifier name, may end with dot
                '(?:[a-z\\u00a1-\\uffff]{2,}\\.?)' +
                ')' +
                // port number (optional)
                '(?::\\d{2,5})?' +
                // resource path (optional)
                '(?:[/?#]\\S*)?' +
                '$',
            'i'
        );

        return regex.test(value);
    },
    message: 'Invalid URL. Must be a full url (i.e. https://www.bandwango.com)'
});
